import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faArrowCircleLeft, faArrowCircleRight, faLocationDot, faPhone, faEnvelope, faEnvelopeOpenText } from '@fortawesome/free-solid-svg-icons';

export default function DynamicIcon(props) {
  const { icon } = props;

  // Get the FontAwesome icon based on the icon prop
  let faIcon;
  switch (icon) {
    case 'facebook':
      faIcon = faFacebook;
      break;
      case 'instagram':
        faIcon = faInstagram;
        break;
        case 'linkedin':
            faIcon = faLinkedin;
            break;
            case 'arrowCircleLeft':
      faIcon = faArrowCircleLeft;
      break;
      case 'arrowCircleRight':
      faIcon = faArrowCircleRight;
      break;
      case 'locationDot':
      faIcon = faLocationDot;
      break;
      case 'phone':
      faIcon = faPhone;
      break;
      case 'email':
        faIcon = faEnvelope;
        break;
        case 'newsletter':
          faIcon = faEnvelopeOpenText;
          break;
    // Add more cases for other icons
    default:
      faIcon = faFacebook; // Default to faFacebook if icon prop is invalid
  }

  return <FontAwesomeIcon icon={faIcon} />;
}